import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from './../../validation.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from './../../_services/index';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css'],
  providers: [AuthenticationService]
})
export class ResetComponent implements OnInit {
  ErrorMassage: any;
  resetForm: any;
  public errorFlag = false;
  loading = false;
  token: string;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private resetpasswordservice: AuthenticationService
  ) { }

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];
    this.validateResetPasswordForm();
    //console.log(typeof this.token);
    if(typeof this.token == 'undefined')
    {
      this.token = '';
    }
  }
  validateResetPasswordForm() {
    this.resetForm = this.formBuilder.group({
      'token': [this.token, [Validators.required]],
      'new_password': ['', [Validators.required, ValidationService.passwordValidator]],
      'confirm_password': ['', [Validators.required, ValidationService.passwordValidator]]
    });
  }

  resetPassword() {
    this.loading = true;
    // let token = this.route.snapshot.queryParams["token"];
    this.resetpasswordservice.resetPassword(
      this.resetForm.value.new_password,
      this.resetForm.value.confirm_password,
      this.resetForm.value.token
    ).subscribe(
      (dataResponse) => {
        const response = dataResponse;
        if (response.success === 1 && response.statusCode === 200) {
          this.ErrorMassage = response.message;
          this.errorFlag = false;
          this.loading = false;
          this.token = this.resetForm.value.token;
          this.resetForm.reset({
            'token': '',
            'new_password': '',
            'confirm_password': ''
          });
        }
      },
      error => {
        this.loading = false;
        const errordata = JSON.parse(error._body);
        if (errordata.success === 0) {
          this.ErrorMassage = errordata.message;
          this.errorFlag = true;
        }

      }
    );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/reset/reset.component.ts